export default __webpack_public_path__ + "static/media/sunset_wide_angle.484c9f1e.jpg";